<h2 class="pb-[2.5rem]" id="develop-myself">
  {{ 'development.developMyself' | transloco }}
</h2>
@if(loading()){
<div class="my-[6.25rem]"><loader /></div>
} @else {
<div
  class="mb-10 flex flex-col md:flex-row md:items-center justify-between gap-4"
>
  <p>{{ 'development.developMyselfDescription' | transloco }}</p>
  @if(userRole()!="User"){
  <toggle
    [isActive]="modeDraft()"
    (toggleChange)="toggleModeDraft()"
    [text]="'components.toggle.showPendingTiles' | transloco"
    class="self-end"
  ></toggle>
  }
</div>

<div class="bento pb-[5rem]">
  @for (tile of tilesDevelopmentToShow(); track tile.id ?? $index) {
  <app-tile
    [id]="tile.id"
    [title]="tile.title"
    [text]="tile.text"
    [variant]="tile.variant"
    [ctaText]="tile.ctaText | transloco"
    [ctaLink]="tile.ctaLink"
    [image]="tile.image"
    [size]="tile.size"
    [isRedirectionExternal]="tile.isExternalLink"
    [textDisclaimer]="tile.textDisclaimer"
    [status]="tile.status"
  ></app-tile>
  }
</div>
}

<themed-section [bgClass]="'bg-vinciBlue-50'">
  <h2 class="pb-[2.5rem]" id="better-know-myself">
    {{ 'development.betterKnowMyself' | transloco }}
  </h2>
  @if(loading()){
  <div class="my-[6.25rem]"><loader /></div>
  } @else {
  <p class="pb-[2.5rem]">
    {{ 'development.betterKnowMyselfDescription' | transloco }}
  </p>
  <div class="bento">
    @for (tile of tilesAboutMeToShow(); track tile.id ?? $index) {
    <app-tile
      [id]="tile.id"
      [title]="tile.title"
      [text]="tile.text"
      [variant]="tile.variant"
      [ctaText]="tile.ctaText | transloco"
      [ctaLink]="tile.ctaLink"
      [image]="tile.image"
      [size]="tile.size"
      [isRedirectionExternal]="tile.isExternalLink"
      [textDisclaimer]="tile.textDisclaimer"
      [status]="tile.status"
    ></app-tile>
    }
  </div>
  }
</themed-section>

<app-favorite-tile-error-modal />
